const translates = {
	en: {
		roiDeleteConfirm: 'are you sure?'
	},
	ru: {
		roiDeleteConfirm: 'Вы уверены?'
	}
};
export default translates;